import { render, staticRenderFns } from "./CmpVxVsSelector.vue?vue&type=template&id=215b5682&"
import script from "./CmpVxVsSelector.vue?vue&type=script&lang=js&"
export * from "./CmpVxVsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports